<template>
  <div>
    <Header navTitle="工时提报" navTip="如果存在多个案件工时登记时，请重复工时填报操作"></Header>
    <div class="box">
      <div class="inputBox">
        <van-form @submit="onSubmit">
          <template v-for="(item, index) in formData" :key="index">
            <van-cell-group style="margin-bottom: 10px;">
              <van-field
                label="登记日期"
                input-align="right"
                readonly
                :model-value="
                  date ||
                  `${new Date().getFullYear()}-${
                    new Date().getMonth() + 1
                  }-${new Date().getDate()}`
                "
              />
              <van-field
                label="案件名称"
                is-link
                input-align="right"
                readonly
                @click="onShowAction(index)"
                v-model="item.name"
                :rules="[{ required: true, message: '请选择案件名称' }]"
              />
              <van-field
                label="事件名称"
                is-link
                input-align="right"
                readonly
                @click="onShowPlanList(index)"
                v-model="item.name1"
                :rules="[{ required: true, message: '请选择事件名称' }]"
              />
              <!-- <van-field
              label="风险描述"
              placeholder="请输入风险描述"
              type="textarea"
              autosize
              input-align="right"
            /> -->
            </van-cell-group>
          </template>

          <van-button
            native-type="submit"
            style="margin-top: 15px"
            type="primary"
            block
            round
            >下一步</van-button
          >
        </van-form>
      </div>
    </div>
    <!-- model -->
    <van-calendar :show="state.showTime" />
    <van-action-sheet
      :show="state.showAction"
      :actions="state.actions"
      close-on-click-overlay
      close-on-click-action
      @select="onSelect"
      @click-overlay="state.showAction = false"
    />
    <van-action-sheet
      :show="state.palnListShow"
      :actions="state.palnList"
      :close-on-click-overlay="true"
      @select="onSelectPaln"
      @click-overlay="state.palnListShow = false"
    />
  </div>
</template>
<script lang="ts">
import Header from '@/components/header.vue';
import { defineComponent, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  Form,
  Icon,
  Field,
  CellGroup,
  Cell,
  Calendar,
  ActionSheet,
  Button,
  Toast,
  SwipeCell,
} from 'vant';
import { getUserSelectCaseList, getUserSelectPlanList } from '@/http/addCase';

export default defineComponent({
  components: {
    [Form.name]: Form,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Calendar.name]: Calendar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [SwipeCell.name]: SwipeCell,
    Header,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { date } = route.query;
    // 时间选择
    const showAction = ref(false);
    const selectIndex = ref(0);
    const formData = ref([
      {
        name: '',
        name1: '',
        parentId: '',
        id: '',
      },
    ]);
    const state: any = reactive({
      showTime: false,
      showAction: false,
      actions: [],
      selectActions: {},
      palnListShow: false,
      palnList: [],
      selectPlanList: {},
      selectTiem: '',
    });
    const onDelete = (index:any) => {
      if (index === 0) {
        Toast('请至少填写一个');
        return;
      }
      formData.value.splice(index, 1);
    };
    // const formatDate = (date: any) => (`${date.getMonth() + 1}/${date.getDate()}`);
    // const onConfirm = (data: any) => {
    //   console.log(data);
    //   state.selectTiem = formatDate(data);
    // };
    const onShowTime = () => {
      state.showTime = true;
    };
    // 案件名称选额
    const onShowAction = (index: any) => {
      selectIndex.value = index;
      state.showAction = true;
    };
    const onSubmit = (errorInfo: any) => {
      console.log('failed', errorInfo);
      const ids = formData.value.map((item: any) => (item.id));
      router.push({
        path: '/caseform',
        query: {
          projectId: ids.join(','),
          time:
            date || `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
          proId: state.selectActions.id,
          type: 1,
        },
      });
    };
    // 选择项目
    const onSelect = (item: any) => {
      console.log(item);
      formData.value[selectIndex.value].name = item.name;
      formData.value[selectIndex.value].parentId = item.id;
      formData.value[0].name1 = '';
      state.showAction = false;
    };
    getUserSelectCaseList().then((res: any) => {
      const list = res.result.map((item: any) => ({
        name: item.caseName,
        id: item.id,
      }));
      state.actions = list;
    });
    // 选择事件名称
    const onShowPlanList = (index: any) => {
      selectIndex.value = index;
      if (!formData.value[index].parentId) {
        Toast('请先选择案件名称');
        return;
      }
      getUserSelectPlanList({
        projectId: formData.value[index].parentId,
      }).then((res: any) => {
        const list = res.result.map((item: any) => ({
          name: item.planName,
          id: item.id,
        }));
        state.palnList = list;
        state.palnListShow = true;
      });
    };
    const onSelectPaln = (item: any) => {
      const is = formData.value.some((data: any) => (data.id === item.id));
      if (is) {
        Toast('请勿重复选择事件名称');
        return;
      }
      formData.value[selectIndex.value].name1 = item.name;
      formData.value[selectIndex.value].id = item.id;
      state.palnListShow = false;
    };
    // 添加
    const onAdd = () => {
      formData.value.push({
        name: '',
        name1: '',
        parentId: '',
        id: '',
      });
    };
    return {
      state,
      onShowTime,
      onShowAction,
      onSubmit,
      onSelect,
      onShowPlanList,
      onSelectPaln,
      showAction,
      date,
      formData,
      onAdd,
      onDelete,
    };
  },
});
</script>

<style lang="scss" scoped>
/deep/ .van-cell {
  padding: 18px 16px;
   .van-cell__title {
    font-size: 16px;
    font-weight: bold;
  }
}

.box {
  padding: 30px 10px 20px 10px;
}
</style>
